import React from 'react';
import { ListItem, ListItemText, ListItemIcon, Typography, IconButton, Link } from '@mui/material';
import { Notifications as NotificationsIcon, Check as CheckIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NotificationItem = ({ notification, onMarkRead }) => {
  const { id, message, type, read, entity_type, entity_id } = notification;
  const navigate = useNavigate();
  
  const handleNotificationClick = () => {
    // Mark as read when clicked
    if (!read) {
      onMarkRead(id);
    }
    
    // Handle navigation for slot notifications
    if (type === 'slot_created' && entity_type === 'slot') {
      // Navigate to vendor dashboard calendar tab (index 2)
      navigate('/vendor/dashboard', { state: { selectedTab: 2 } });
    }
  };
  
  const handleMarkRead = (e) => {
    e.stopPropagation(); // Prevent triggering the main click handler
    if (!read) {
      onMarkRead(id);
    }
  };

  const isClickable = type === 'slot_created' && entity_type === 'slot';

  // Format message to make "Click to view calendar" appear as a link
  const formatMessage = (message) => {
    if (isClickable && message.includes('Click to view calendar')) {
      const parts = message.split('Click to view calendar');
      return (
        <>
          {parts[0]}
          <Link 
            component="span" 
            sx={{ 
              cursor: 'pointer', 
              textDecoration: 'underline',
              color: 'primary.main',
              fontWeight: 'medium'
            }}
          >
            Click to view calendar
          </Link>
          {parts[1]}
        </>
      );
    }
    return message;
  };

  return (
    <ListItem
      alignItems="flex-start"
      onClick={isClickable ? handleNotificationClick : undefined}
      sx={{
        backgroundColor: read ? 'transparent' : 'action.hover',
        '&:hover': { 
          backgroundColor: isClickable ? 'primary.light' : 'action.selected',
          '& .MuiLink-root': {
            color: isClickable ? 'primary.contrastText' : 'primary.main'
          }
        },
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'background-color 0.2s ease'
      }}
      secondaryAction={
        !read && (
          <IconButton edge="end" onClick={handleMarkRead} size="small">
            <CheckIcon />
          </IconButton>
        )
      }
    >
      <ListItemIcon>
        <NotificationsIcon color={read ? "disabled" : "primary"} />
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography variant="body2" component="div">
            {formatMessage(message)}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default NotificationItem;